import request from '../utils/request'
const {tenantContentPath,ocpSaasPath} = window.globalConfig;
export default class LoginApi {
    static login = (params) => {
        return request.post(`/${ocpSaasPath}/system/0/admin/login`, params)
    }
    static logout = (params) => {
        return request.post(`/${ocpSaasPath}/system/0/admin/logout`, params)
    }
    static queryUserLoginList = (params) => {
        return request.post(`/${ocpSaasPath}/api/0/userLoginLogs/queryUserLoginList`, params)
    }
    /**
     * 获取数据库节点
     * @param params
     * @returns {*|Promise<*>}
     */
    static getDBbyCcode = (params) => {
        return request.post(`/${tenantContentPath}/system/tenantLegalVerify/getDBbyCcode`,params)
    }

    /**
     * 登录账户校验
     */
    static loginCheck=(params)=>{
        return request.post(`/${tenantContentPath}/system/0/admin/loginCheck`,params)
    }
}
